import React from 'react';
import styled, { css } from 'styled-components';
import { ImageOrientation, useGetImageOrientation } from 'hooks/use-get-image-orientation';
import MetaTags from 'components/meta-tags';
import useInstoreCart from 'hooks/use-instore-cart';
import { CommonLayoutHeader } from 'src/payments/layout/common/header';
import { useObserver } from 'mobx-react-lite';

type DutchiePayLayoutProps = {
  children: React.ReactNode;
  darkBg?: boolean;
};

export function InstoreCartLayout(props: DutchiePayLayoutProps): JSX.Element | null {
  const { children, darkBg } = props;
  const InstoreCart = useInstoreCart();
  const dispensaryLogo = useObserver(() => InstoreCart.dispensary.logo ?? '');
  const dispensaryName = useObserver(() => InstoreCart.dispensary.name ?? `Company`);

  const { imageOrientation } = useGetImageOrientation(dispensaryLogo);
  return (
    <>
      <MetaTags />
      <Container darkBg={darkBg}>
        <CommonLayoutHeader />
        <ContentContainer>
          {dispensaryLogo && (
            <LogoContainer>
              <DispensaryLogo
                src={dispensaryLogo}
                orientation={imageOrientation}
                alt={`${String(dispensaryName)} Logo`}
              />
            </LogoContainer>
          )}
          {children}
        </ContentContainer>
      </Container>
    </>
  );
}

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
`;

const DispensaryLogo = styled.img`
  max-height: ${(props) => (props.orientation === ImageOrientation.vertical ? '32px' : '56px')};
`;

const Container = styled.div<{ darkBg?: boolean }>`
  ${({ theme: { colors }, darkBg }) => css`
    /* Setting css vars on a parent scope makes them available to all child dom nodes */
    --dp-content-width: 450px;
    height: 100%;
    width: 100%;
    padding-bottom: 24px;
    background-color: ${darkBg ? colors.dutchiePayGreen : colors.white};
  `}
`;

const ContentContainer = styled.div`
  width: 100%;
  max-width: var(--dp-content-width);
  padding: 18px 24px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
